import { render, staticRenderFns } from "./BadgeLabelEl.vue?vue&type=template&id=115c9301&scoped=true&"
import script from "./BadgeLabelEl.vue?vue&type=script&lang=ts&"
export * from "./BadgeLabelEl.vue?vue&type=script&lang=ts&"
import style0 from "./BadgeLabelEl.vue?vue&type=style&index=0&id=115c9301&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115c9301",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSheet,VTextField})
